import React from "react";
import { Box, Text, Heading } from "@chakra-ui/react";
const Header = () => {
  return (
    <Box w="100%">
      <Heading mb="24px" fontWeight="600" color="#12344D" fontSize="18px">
        Configure form settings
      </Heading>
      <Heading mb="8px" fontWeight="600" color="#12344D" fontSize="16px">
        Form submission settings
      </Heading>
      <Text fontSize="14px" fontWeight="400" color="#475867">
        What should happen after a visitor submits a form
      </Text>
    </Box>
  );
};

export default Header;
